// extracted by mini-css-extract-plugin
module.exports = {"listItem":"DeviceDetails_listItem__2v3B4","switchImage":"DeviceDetails_switchImage__35F-9","buttons":"DeviceDetails_buttons__3j2WO"};